module.exports = __webpack_public_path__ + "310c1d677214fb74dd6dfbfeaee3db64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/kyoto.jpg
// module id = 643
// module chunks = 47